<template lang="pug">
  v-btn(
    @click="openMenu"
    icon)
    v-icon(title="preferences") {{ mdiMenu }}
</template>

<script>
import { page } from '@iez/core'
import { reactive, toRefs, computed, ref } from '@vue/composition-api'
import data from '@iez/lib/data'
import { mdiMenu } from '@mdi/js'
import getBlockingMenuItems from './get-blocking-menu-items/'

export default {
  setup () {
    const menuOpened = ref(false)

    const me = data.me({
      fields: [
        'id',
        'isAdmin', {
          association: [
            `id`
          ]
        }
      ]
    })

    const state = reactive({
      me
    })

    const { items, itemBottom } = getBlockingMenuItems({
      isAdmin: computed(() => state.me?.isAdmin),
      isAssociation: computed(() => state.me?.association?.id)
    })

    page.blockingDrawer.set({
      activeWhen: () => menuOpened.value,
      blockingDrawer: {
        title: `Préferences`,
        items,
        itemBottom,
        version: `1.1`,
        onClose: () => {
          menuOpened.value = false
        }
      }
    })

    const openMenu = () => {
      menuOpened.value = true
    }

    return {
      openMenu,
      mdiMenu,
      ...toRefs(state)
    }
  }
}
</script>
